import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled, {css} from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import {
  deleteRerralCode,
  registerSalesManager,
  searchSalesProfileDetail,
} from 'function/api';
import DefaultButton from 'components/common/DefaultButton';
import CommonModal from 'components/common/CommonModal';
import ContainerHeader from 'components/common/ContainerHeader';
import PhoneNumberInput from 'components/common/PhoneNumberInput';
import {countryArray} from 'data/country';
import LabelInput from 'components/common/LabelInput';
import {getDevice} from 'utils/getDevice';
import {useLocation, useNavigate} from 'react-router-dom';
import {formatPhoneNumber} from 'utils/fomatPhoneNumber';
import moment from 'moment';
import DefaultInput from 'components/common/DefaultInput';
import RegisterReferralCodeModal from 'components/salesManagement/RegisterReferralCodeModal';
import DiscardCodeModal from 'components/salesManagement/DiscardCodeModal';

export default function SalesManagerDetail() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});
  const device = getDevice();
  const [modal, setModal] = useState('');
  const userInfo = useRecoilValue(userInfoState);

  const location = useLocation();
  const uuid = location.state;

  const [info, setInfo] = useState<any>();
  // const [referralCode, setReferralCode] = useState<any>();

  const [selectItem, setSelectItem] = useState<null | any>(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo) {
      searchSalesProfileDetail({
        userInfo,
        setIsLoading,
        setErrorModal,
        salesManagerUUID: uuid,
      }).then(result => {
        setInfo(result);
      });
    }
  }, [userInfo, uuid]);

  const modalData: {[key: string]: any} = {
    deleteCode: {
      title: '추천 코드를 삭제하시겠습니까?',
      firstButtonText: 'confirm',
      secondButtonText: 'cancel',
      firstButtonClick: async () => {
        const result = await deleteRerralCode({
          userInfo,
          setIsLoading,
          setErrorModal,
          referralCodeUUID: info?.referralCode?.uuid,
        });
        if (result) {
          setModal('');
          window.location.reload();
        }
      },
      secondButtonClick: () => setModal(''),
    },
  };

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader mainTitle="세일즈 파트너 상세보기" />
        <Inner $device={device}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <DefaultText
              text="세일즈 파트너 정보"
              textStyle={{
                fontSize: minmax(25),
                fontWeight: 'bold',
                borderBottom: `3px solid ${colors.primary}`,
                width: 'fit-content',
                textWrap: 'nowrap',
                height: 'fit-content',
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                width: '100%',
              }}>
              <DefaultButton
                text={'toModify'}
                buttonStyle={{
                  backgroundColor: colors.primary2,
                  width: 'fit-content',
                  padding: minmax(30),
                }}
                textStyle={{color: colors.white}}
                onClick={() =>
                  navigate('/SalesManagerEdit', {
                    state: uuid,
                  })
                }
              />
            </div>
          </div>
          <LabelInput
            labelText="파트너 회사명"
            type="text"
            value={info?.userProfile?.salesPartnerCompanyName || '-'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="managerName"
            type="text"
            value={info?.userProfile?.name || '-'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="phone"
            type="text"
            value={formatPhoneNumber({phone: info?.userProfile?.phone || ''}) || '-'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="이메일"
            type="text"
            value={info?.userProfile?.email || '-'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="가입일"
            type="text"
            value={
              moment(info?.userProfile?.createdAt)?.format('YYYY-MM-DD') || '-'
            }
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="상태"
            type="text"
            value={
              info?.userProfile?.deletedAt
                ? '삭제'
                : info?.userProfile?.isBlock
                ? '정지'
                : '등록'
            }
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="등록된 시공사 수"
            type="text"
            value={(info?.registerContractorTotalCount || 0) + '개'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <Border />

          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <DefaultText
              text="추천 코드"
              textStyle={{
                fontSize: minmax(25),
                fontWeight: 'bold',
                borderBottom: `3px solid ${colors.primary}`,
                width: 'fit-content',
                textWrap: 'nowrap',
                height: 'fit-content',
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                width: '100%',
              }}>
              <DefaultButton
                text={'삭제하기'}
                buttonStyle={{
                  backgroundColor: colors.vividRed,
                  width: 'fit-content',
                  padding: minmax(30),
                }}
                textStyle={{color: colors.white}}
                onClick={() =>
                  info?.referralCode?.code ? setModal('deleteCode') : null
                }
              />
            </div>
          </div>

          <LabelInput
            labelText="추천코드"
            type="text"
            value={info?.referralCode?.code || '미발행'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="만료일"
            type="text"
            value={
              info?.referralCode?.expiredAt
                ? moment(info?.referralCode?.expiredAt).format('YYYY-MM-DD')
                : '-'
            }
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInputWrap>
            <Label>
              <DefaultText text={'상태'} />
            </Label>
            <div
              style={{
                height: minmax(60),
                width: '100%',
                fontSize: minmax(20),
                display: 'flex',
                alignItems: 'center',
              }}>
              <DefaultText
                text={
                  info?.referralCode
                    ? info?.referralCode?.isDiscarded
                      ? '비활성'
                      : '활성'
                    : '-'
                }
                textStyle={{cursor: 'pointer', paddingLeft: minmax(20)}}
              />
            </div>
          </LabelInputWrap>
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal]?.title}
          detail={modalData[modal]?.detail}
          firstButtonText={modalData[modal]?.firstButtonText}
          firstButtonStyle={modalData[modal]?.firstButtonStyle}
          secondButtonText={modalData[modal]?.secondButtonText}
          secondButtonStyle={modalData[modal]?.secondButtonStyle}
          firstButtonClick={modalData[modal]?.firstButtonClick}
          secondButtonClick={modalData[modal]?.secondButtonClick}
          closeModal={() => setModal('')}
        />
      )}
    </ScreenLayout>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div<{$device?: string}>`
  width: 70%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(40)};
  padding-top: 0;
  gap: ${minmax(40)};

  ${(props: any) =>
    props.$device === 'mobile' &&
    css`
      width: 90%;
      min-width: auto;
    `}
`;

const Border = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.borderGray};
`;

const Label = styled.label<{$isColumn?: boolean}>`
  font-size: ${minmax(20)};
  font-weight: 400;
  width: 20%;
  height: 100%;
  padding-right: 2%;
  display: flex;
  justify-content: start;
  align-items: center;
  word-break: break-all;
  ${(props: any) =>
    props.$isColumn &&
    css`
      width: 100%;
      margin-bottom: 12px;
    `}
`;

const LabelInputWrap = styled.div<{$isColumn?: boolean}>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  ${(props: any) =>
    props.$isColumn &&
    css`
      flex-direction: column;
      height: auto;
    `}
`;
